export const filterByLabelFormat = (val = {}, labelFormat) => {
  return labelFormat.replace(/{[a-zA-Z]+}/g, (key) => val[key.replace(/[{}]/g, '')] || '')
}
